define.alias("shared/components/shared/feature-upgrade-banner", "settings/components/shared/feature-upgrade-banner");